import { useQuery } from '@tanstack/react-query';
import { fetchSplitDistribution, type GraphFilters } from '../services/graphApi';

export function useSplitDistributionQuery(
  eventId: number | null,
  refreshIntervalMs = 0,
  filters?: GraphFilters
) {
  return useQuery({
    queryKey: ['split-distribution', eventId, filters],
    queryFn: () => fetchSplitDistribution(eventId ?? 0, filters),
    enabled: eventId != null,
    refetchInterval: refreshIntervalMs > 0 ? refreshIntervalMs : false,
  });
}
